module.exports = __webpack_public_path__ + "static/img/erweima.741a204.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/erweima.png
// module id = hMRt
// module chunks = 15